import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import GenericTouchable from "./GenericTouchable";
var TouchableWithoutFeedback = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsx(GenericTouchable, _object_spread({
        ref: ref
    }, props));
});
TouchableWithoutFeedback.defaultProps = GenericTouchable.defaultProps;
export default TouchableWithoutFeedback;
